var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3136",
  "data-name": "Group 3136",
  transform: "translate(-12648 1256)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon_47",
  "data-name": "Polygon 47",
  d: "M7.106,1.789a1,1,0,0,1,1.789,0l6.382,12.764A1,1,0,0,1,14.382,16H1.618a1,1,0,0,1-.894-1.447Z",
  transform: "translate(12648 -1256)",
  fill: "#ffea46"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3135",
  "data-name": "Group 3135",
  transform: "translate(12629.9 -1268)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M26.709,22.316l-.077.786a.255.255,0,0,1-.255.23h-.558a.255.255,0,0,1-.255-.23L25.1,18.278a.252.252,0,0,1,.066-.195.257.257,0,0,1,.19-.083h1.486a.257.257,0,0,1,.19.083.252.252,0,0,1,.066.2l-.243,2.514Z",
  transform: "translate(0 0)",
  fill: "#212121"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  cx: 0.759,
  cy: 0.801,
  rx: 0.759,
  ry: 0.801,
  transform: "translate(25.34 24.399)",
  fill: "#212121"
})))));
export default __webpack_public_path__ + "static/media/requestalert.c7c3ecb9.svg";
export { SvgComponent as ReactComponent };